import { Routes, Route } from 'react-router';
import { ErrorBoundary } from './components/ErrorBoundary';
import { ProtectedRoute } from './components/ProtectedRoute';
import { Layout } from './components/Layout';
import { Landing } from './pages/Landing';
import { Pitch } from './pages/Pitch';
import { Login } from './pages/Login';
import { Callback } from './pages/Callback';
import { Onboarding } from './pages/Onboarding';
import { Dashboard } from './pages/Dashboard';
import { ApiKeys } from './pages/ApiKeys';
import { Traces } from './pages/Traces';
import { TraceDetail } from './pages/TraceDetail';
import { SessionDetail } from './pages/SessionDetail';
import { Approvals } from './pages/Approvals';
import { Budgets } from './pages/Budgets';
import { RateLimits } from './pages/RateLimits';
import { Policies } from './pages/Policies';
import { Security } from './pages/Security';
import { Anomalies } from './pages/Anomalies';
import { Members } from './pages/Members';
import { Settings } from './pages/Settings';
import { Billing } from './pages/Billing';
import { Terms } from './pages/Terms';
import { Privacy } from './pages/Privacy';
import { Docs } from './pages/Docs';

export function App() {
  return (
    <ErrorBoundary>
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/pitch" element={<Pitch />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/docs" element={<Docs />} />
      <Route path="/login" element={<Login />} />
      <Route path="/callback" element={<Callback />} />
      <Route
        path="/onboarding"
        element={
          <ProtectedRoute>
            <Onboarding />
          </ProtectedRoute>
        }
      />
      <Route
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/api-keys" element={<ApiKeys />} />
        <Route path="/traces" element={<Traces />} />
        <Route path="/traces/:taskId" element={<TraceDetail />} />
        <Route path="/sessions/:sessionId" element={<SessionDetail />} />
        <Route path="/approvals" element={<Approvals />} />
        <Route path="/budgets" element={<Budgets />} />
        <Route path="/rate-limits" element={<RateLimits />} />
        <Route path="/policies" element={<Policies />} />
        <Route path="/security" element={<Security />} />
        <Route path="/anomalies" element={<Anomalies />} />
        <Route path="/team" element={<Members />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/billing" element={<Billing />} />
      </Route>
    </Routes>
    </ErrorBoundary>
  );
}
